//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const SCHEDULER_POST_DETAILS_FORM_ID = 'post-details-form';

export const POST_DETAILS_TIME_REQUIRED_ERROR =
  'Please select a date and time, or save as a draft.';

export const SELECTED_POST_TIME_IN_PAST_ERROR =
  'Please select a date and time in the future, or save as a draft.';

export const MAX_SHOP_TAG_COUNT = 5; // Limit is from the container creation endpoint: https://developers.facebook.com/docs/instagram-api/reference/ig-user/media#creating

export const POST_DETAILS_NO_NOTIFICATION_USERS_TEXT =
  'You have no users with the Bazaarvoice mobile app. Download and sign in to the app to select a user.';

export const POST_DETAILS_NO_NOTIFICATION_USERS_ERROR =
  'You must choose who should receive notifications for this post, or save it as a draft.';

export const POST_DETAILS_INVALID_TAGGED_USER_TEXT =
  'Your post contains one or more users that are private or do not exist. Please check your tagged users and try again.';

export const DEFAULT_FRAMES_PER_SECOND = 30;
